const beans = [
  'fredbeans.com',
  'fredbeanscadillacbuickgmc.com',
  'fredbeanschevrolet.com',
  'fredbeansdodgechryslerjeep.com',
  'fredbeansfordnewtown.net',
  'fredbeansboyertown.com',
  'fredbeansford.net',
  'fredbeansfordexton.com',
  'fredbeansfordlanghorne.com',
  'fredbeansfordmechanicsburg.net',
  'fredbeansfordwashington.com',
  'fbwestchester.com',
  'fredbeanshyundai.com',
  'fredbeanshyundaiflemington.com',
  'fredbeanshyundailanghorne.com',
  'fredbeanskialanghorne.com',
  'fredbeanskiamechanicsburg.com',
  'fredbeanslincoln.com',
  'nissanofdoylestown.com',
  'fredbeansnissanflemington.com',
  'fredbeanssubaru.com',
  'fredbeanstoyota.com',
  'vwfredbeans.com',
  'vwofdoylestown.com',
  'genesisofdoylestown.net'
]

export const isBeans = () => beans.some(bean => location.host.endsWith(bean))

export const beansSrc = 'https://cdn.max.auto/M4W/beans.png'
